import { HeaderRequestId, awApi } from '@blk/aw-api-clients';
import moment from 'moment';
import { BaseLogger } from '../BaseLogger';
import { AW_ADVISOR_APP_NAME } from '../constants';
import { AppMetadata, TrackingData } from '../models';
import { LoggerUtil } from '../utils';

export class GenStatsLogger implements BaseLogger {
  private static appMetadata: AppMetadata;
  /*
   * Mappings to GenStat, can be updated as per the requirement from the app
   * [key] as a target object key and value as a source object key
   */
  private static payloadMappings: { [key: string]: string } = {
    key2: 'action',
    key3: 'actionInfo',
    key4: 'area',
    attrib1: 'additionalInfo1',
    attrib2: 'additionalInfo2',
    data1: 'float1',
    data2: 'float2',
    data3: 'float3',
    data4: 'float4',
  };
  initLogger(appMetadata: AppMetadata): Promise<void> {
    return new Promise((resolve) => {
      GenStatsLogger.appMetadata = appMetadata;
      resolve();
    });
  }
  trackEvent(trackingData: TrackingData): void {
    const date = new Date();
    const asOfDate = moment().utc().valueOf();
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    const headerRequestId = new HeaderRequestId();
    const payload = {
      key5: GenStatsLogger.appMetadata.pkg,
      subModule:
        GenStatsLogger.appMetadata.applicationNameFn?.() ??
        (GenStatsLogger.appMetadata.applicationName || AW_ADVISOR_APP_NAME),
      tagDef: 'ARWMTag',
      asOfDate,
      endDate: asOfDate,
      date1: date.getTime(),
      [HeaderRequestId.NAME]: headerRequestId.getId(),
      ...LoggerUtil.translateObject(trackingData, GenStatsLogger.payloadMappings),
    };
    GenStatsLogger.postGenStat(payload, headerRequestId).catch((e: Error) => {
      console.warn(
        `The failed call to "stats/v2" is non-fatal. This call is for logging user actions, which is not required for the app to run or function properly.\nRequest ID: ${headerRequestId.getId()}\n`,
        e
      );
    });
  }
  public static setPayloadMappings(payloadMappings: { [key: string]: string }): void {
    GenStatsLogger.payloadMappings = { ...GenStatsLogger.payloadMappings, ...payloadMappings };
  }

  public static getPayloadMappings(): { [key: string]: string } {
    return GenStatsLogger.payloadMappings;
  }

  public static postGenStat(payload: unknown, headerRequestId: HeaderRequestId) {
    const path = '/stats/v2';
    return awApi.post(path, payload, { headers: headerRequestId.toHeader() });
  }
}
